import { Button, Drawer, Grid, Space, Typography } from 'antd';
import type { FilterConfig } from '@/components/FilterBar/FilterBar';

const { useBreakpoint } = Grid;

interface Props {
  open: boolean;
  onClose: () => void;
  /** Nhóm filter nâng cao — xem `buildOrderAdvancedFilters`. */
  filters: FilterConfig[];
  /** Số filter (toàn trang) đang áp dụng — hiển thị trên nút xoá. */
  activeCount: number;
  onClear: () => void;
}

/**
 * Drawer "Bộ lọc" của danh sách đơn hàng (TCR-1092 vòng 2).
 *
 * Vì sao không dùng nhánh drawer sẵn có trong `FilterBar`: nhánh đó chỉ bật khi màn hình
 * hẹp hoặc `collapseToButton`, và khi bật thì GOM CẢ ô tìm kiếm/kênh/thời gian vào drawer —
 * trong khi yêu cầu là ba ô đó phải ở ngoài. Sửa `FilterBar` để tách hai nhóm sẽ đụng ~50
 * trang khác đang dùng chung component; dựng drawer riêng ở đây rẻ hơn và không lan rủi ro.
 *
 * Filter áp dụng ngay khi chọn (instant-apply, giống thanh lọc ngoài) nên drawer không có
 * nút "Áp dụng" — thêm nút đó sẽ tạo tầng nháp thứ hai, đúng thứ đã gây lỗi ở vòng trước.
 */
export function OrderFilterDrawer({ open, onClose, filters, activeCount, onClear }: Props) {
  const screens = useBreakpoint();

  return (
    <Drawer
      title="Bộ lọc đơn hàng"
      placement="right"
      width={screens.md ? 420 : '100%'}
      open={open}
      onClose={onClose}
      data-testid="order-filter-drawer"
    >
      <Space direction="vertical" size={12} style={{ width: '100%' }}>
        {filters.map((f) => (
          <div key={f.key}>
            {/* Không dùng `type="secondary"`: nhãn xám nhạt khó đọc trên nền trắng của drawer,
                tester báo không phân biệt được tên filter. Để màu chữ mặc định (gần đen). */}
            <Typography.Text style={{ fontSize: 12, display: 'block', marginBottom: 4 }}>
              {f.label}
            </Typography.Text>
            {f.render()}
          </div>
        ))}
        {activeCount > 0 && (
          <Button
            block
            data-testid="order-filter-drawer-clear"
            onClick={() => {
              onClear();
              onClose();
            }}
          >
            Xóa bộ lọc ({activeCount})
          </Button>
        )}
      </Space>
    </Drawer>
  );
}
